import React from 'react';
import { MultiSelect, Option } from 'carbon-react/lib/components/select';

import { TextMatchFilterFieldConfig } from '../types';

interface TextMatchFilterFieldProps {
  config: TextMatchFilterFieldConfig;
  onChange: (key: string, selectedValues: string[]) => void;
}

/**
 * Component for rendering a text match filter field in the filters sidebar, allowing users to select multiple options from a dropdown
 * @param config - The configuration for the text match filter field
 * @param onChange - Function to call when the selected values change
 * @returns A JSX element representing the text match filter field
 */
export const TextMatchFilterField = ({ config, onChange }: TextMatchFilterFieldProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(config.key, (event.target.value as unknown) as string[]);
  };

  return (
    <MultiSelect
      name={`filter-${config.key}`}
      id={`filter-${config.key}`}
      label={config.label}
      placeholder={config.placeholder || ''}
      value={config.selectedValues}
      onChange={handleChange}
    >
      {config.options.map(option => (
        <Option key={option.value} text={option.text} value={option.value} />
      ))}
    </MultiSelect>
  );
};
